import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';

import cn from 'classnames';

import Button from '../../../Button';
import FormLabel from '../FormLabel';
import FormError from '../FormError';
import FormGroup from '../FormGroup';

import './style.scss';

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

class FormGroupFile extends Component {
  static propTypes = {
    accept: PropTypes.string,
    description: PropTypes.string,
    icon: PropTypes.node,
    input: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
      ]),
      onChange: PropTypes.func,
    }),
    label: PropTypes.node,
    meta: PropTypes.shape({
      error: PropTypes.string,
      touched: PropTypes.bool,
    }),
    multiple: PropTypes.bool,
    onChangeFiles: PropTypes.func,
  };

  static defaultProps = {
    description: 'file',
    multiple: false,
    input: {
      name: '',
      value: '',
    },
    meta: {
      touched: false,
      error: '',
    },
  };

  handleDrop = files => {
    const { multiple, onChangeFiles, input } = this.props;
    const filesToSend = multiple ? files : files[0];

    input.onChange(filesToSend);
    if (onChangeFiles) {
      onChangeFiles(filesToSend);
    }
  };

  handleDeselectFile = e => {
    const { input, onChangeFiles } = this.props;
    e.preventDefault();
    e.stopPropagation();
    input.onChange(null);

    if (onChangeFiles) {
      onChangeFiles(null);
    }
  };

  hasFile = ({ value }) => value !== '';

  renderContent = () => {
    const { input, accept, description, icon, multiple } = this.props;
    const hasFile = this.hasFile(input);
    const { value } = input;

    return (
      <Dropzone
        accept={accept}
        multiple={multiple}
        styleName="drop-zone"
        onDrop={this.handleDrop}
        data-test="drop-zone"
      >
        <div styleName="title">
          {icon}
          Drop {description} here to import, or{' '}
          <Button isLink data-test="browse" type="button">
            browse
          </Button>
        </div>

        <div
          data-test="files-wrap"
          styleName={cn({
            'file-name-wrap': true,
            'has-multiple-files': multiple && hasFile,
          })}
        >
          {!hasFile
            ? 'No file'
            : !multiple && (
                <div>
                  <span>{value.name}</span>
                  <i
                    className="icon-close"
                    data-test="remove-button"
                    styleName="remove-button"
                    onClick={this.handleDeselectFile}
                  />
                </div>
              )}
        </div>
      </Dropzone>
    );
  };

  render() {
    const {
      input,
      label,
      meta: { touched, error },
    } = this.props;

    return (
      <FormGroup>
        {label && <FormLabel htmlFor={input.name}>{label}</FormLabel>}

        <div styleName={cn('file-upload')}>{this.renderContent()}</div>

        {touched && error && <FormError>{error}</FormError>}
      </FormGroup>
    );
  }
}

export default FormGroupFile;
